import { __assign, __rest } from "tslib";
import * as React from 'react';
import { CnDialog, CnMenu, CnMenuItem, CnBadge } from '@cainiaofe/cn-ui';
import { getDataSource } from './utils';
var propsRender = function (props) {
    var message = props.message, options = props.options, disabledIndexes = props.disabledIndexes, onClick = props.onClick, rest = __rest(props, ["message", "options", "disabledIndexes", "onClick"]);
    var dataSource = getDataSource(options);
    var disabledIndexesSet = new Set(disabledIndexes);
    return __assign(__assign({ title: message, footer: false, closeMode: ['mask', 'close', 'esc'] }, rest), { content: (React.createElement("div", null,
            React.createElement(CnMenu, null, dataSource.map(function (item, index) { return (React.createElement(CnMenuItem, __assign({ onClick: function (e) { return onClick(item.originalItem, index, e); }, disabled: disabledIndexesSet.has(index) }, item),
                item.text,
                item.badge && (React.createElement(CnBadge, { shape: item.badgeType, style: { marginLeft: 8 } }, item.badge)))); })))) });
};
export var CnActionSheet = function (props) {
    var dialogProps = propsRender(props);
    dialogProps.children = dialogProps.content;
    return React.createElement(CnDialog, __assign({}, dialogProps));
};
CnActionSheet.show = function (props) {
    var dialogProps = propsRender(props);
    dialogProps.children = dialogProps.content;
    return CnDialog.show(dialogProps);
};
